<template>
    <div id="width100">
        <div class="center">
            <div
                id="newsletter-content"
                class="width100 paddingtop10 paddingbottom10"
            >
                <div
                    class="width100 floatnone textcenter paddingtop20 paddingbottom20"
                >
                    <div class="background-stripe"></div>
                    <div
                        id="footerquotes"
                        style="margin-top: -19px ; !important;"
                    >
                        <transition-group name="fade">
                            <div
                                v-for="(review, index) in reviews"
                                :key="'review' + index"
                                v-show="index === currentIndex"
                                class="lichtgreybg floatnone textcenter quote-item"
                            >
                                <span class="newshead font12  bold"
                                    >"{{ review.text }}"</span
                                >
                                -
                                <span class="newssub font12">{{
                                    review.name
                                }}</span>
                                <span class="quote-stars">
                                    <font-awesome-icon icon="star" />
                                    <font-awesome-icon icon="star" />
                                    <font-awesome-icon icon="star" />
                                    <font-awesome-icon icon="star" />
                                    <font-awesome-icon icon="star" />
                                </span>
                            </div>
                        </transition-group>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HeroReviews',
    data: function() {
        return {
            currentIndex: 0,
            reviews: [
                {
                    text: 'Super begeleiding van het boeken tot aan de cruise.',
                    name: 'Yvonne van Gerwen',
                },
                {
                    text:
                        'Medewerkers zijn ontzettend klantgericht, meedenkend, en behulpzaam.',
                    name: 'Kishan Bhadjan',
                },
                {
                    text:
                        'Wij hebben meerdere cruises gemaakt maar nog niet eerder deze persoonlijke benadering gehad.',
                    name: 'G Zonnenberg',
                },
                {
                    text:
                        'We kregen een presentje als voorschot op de reis, wat we erg attent vonden.',
                    name: 'G. Schwarte',
                },
                {
                    text:
                        'Vanaf het eerste contact tot het laatste gesprek zijn wij zo goed geholpen en heel eerlijk geadviseerd.',
                    name: 'G.A. Goethals',
                },
                {
                    text:
                        'Vooraf werden we zelfs gebeld om ons een fijne vakantie te wensen en achteraf om te horen hoe het was geweest.',
                    name: 'Daantje',
                },
                {
                    text:
                        'Naast een duidelijke website werden we begeleid door zeer vriendelijke en deskundige medewerkers.',
                    name: 'Leo Andeweg',
                },
            ],
        }
    },
    methods: {
        nextReview() {
            if (this.currentIndex >= this.reviews.length - 1) {
                this.currentIndex = 0
            } else {
                this.currentIndex += 1
            }
        },
        startSlides: function() {
            let self = this
            setTimeout(function() {
                self.nextReview()
                self.startSlides()
            }, 4000)
        },
    },
    computed: {
        reviewCount: function() {
            return this.reviews.length
        },
    },
    mounted: function() {
        this.startSlides()
    },
}
</script>

<style scoped></style>
